import React from 'react';

import { useFormSelector } from '../../../../custom-hooks';
import {
  getActiveSubGrids,
  getGrandchidlrenForVirtualControl,
} from '../../../selectors/runtime.selectors';
import { equalityFn, getIndexForControlsInsideTable } from '../../../utils/form-manager.utils';
import VirtualDynamicField from '../../VirtualDynamicField';

const VirtualRow = ({
  id,
  columns,
  hiddenColumnsMap,
  rowIndex,
  index,
  isHidden,
  isViewOnly,
  subgridId,
  isParentlessTable,
  containersProps,
  gridLabel,
  gridIndex,
}) => {
  const childrenNodes = useFormSelector(
    getGrandchidlrenForVirtualControl,
    {
      childrenIds: columns.map(({ columnKey }) => columnKey),
    },
    equalityFn
  );
  const activeSubGrids = useFormSelector(getActiveSubGrids, {}, equalityFn);

  const gridArrIndex = getIndexForControlsInsideTable(index, rowIndex, isParentlessTable);
  const instanceId = `${subgridId}#[${gridArrIndex}]`;
  const subGridProps = {
    label: gridLabel,
    id,
    isActive: activeSubGrids.includes(instanceId),
    subGridInstanceId: instanceId,
  };
  const newContainersProps = Array.isArray(containersProps)
    ? [...containersProps, subGridProps]
    : [subGridProps];

  return (
    <>
      {childrenNodes.map((childObj) => (
        <VirtualDynamicField
          id={childObj.id}
          key={`${childObj.id}#${gridArrIndex.join(',')}`}
          gridIndex={gridIndex}
          index={gridArrIndex}
          isParentHidden={isHidden || hiddenColumnsMap[childObj.parent]}
          isParentViewOnly={isViewOnly || !!subgridId}
          containersProps={containersProps}
        />
      ))}
      {subgridId && (
        <VirtualDynamicField
          id={subgridId}
          index={gridArrIndex}
          isParentHidden={isHidden}
          isParentViewOnly={isViewOnly}
          containersProps={newContainersProps}
        />
      )}
    </>
  );
};

export default React.memo(VirtualRow);
